<script lang="ts">
	import { makeComponentClassList } from "../utils";
	export let active = false;
	export let inline = false;

	$: classVariables = makeComponentClassList($$props);

</script>

<nav class:active class:inline class={classVariables}>
	<slot />
</nav>

<style lang="scss">
	nav {
		font-size: 1.125rem;
		color: var(--default-nav);
		transition: color 0.15s;
		text-align: center;

		&:hover {
			color: white;
			cursor: pointer;
		}

		&.active {
			color: var(--signature-blue);
		}

		&.inline {
			display: inline;
		}
	}

</style>
